"use client";

import { useMemo } from "react";
import { useSearchParams } from "next/navigation";
import { parseOnboardingHarnessQuery } from "./onboardingHarnessQuery";

/** V3 onboarding Figma harness — 读 URL `harness*` query（仅 dev / NEXT_PUBLIC_HARNESS=1） */
export function useOnboardingHarnessQuery() {
  const searchParams = useSearchParams();

  return useMemo(
    () => parseOnboardingHarnessQuery(searchParams),
    [searchParams],
  );
}
